import * as _ from "lodash";
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper";
import "../models/index.js";
import { OperationCheckTypes, DisabledInfoLevel, TransitionGateStates } from "../models/OperationCheckModels.js";
import { ExperimentStepType } from "../models/FeatureDataModel.js";
class OperationCheckUtils {
  operationTypeToString(operationCheckType) {
    return OperationCheckTypes[operationCheckType];
  }
  isOperationDisabled(operationChecks, operationCheckType) {
    if (!!operationChecks) {
      return this.isOperationDisabledDict(operationChecks.operationCheckDictionary, operationCheckType);
    }
    return false;
  }
  isOperationDisabledDict(operationCheckDictionary, operationCheckType) {
    const operationTypeStr = this.operationTypeToString(operationCheckType);
    if (!!operationCheckDictionary && !!operationCheckDictionary[operationTypeStr] && !!operationCheckDictionary[operationTypeStr].IsDisabled) {
      return operationCheckDictionary[operationTypeStr].IsDisabled;
    }
    return false;
  }
  getOperationCheckValue(operationCheckDictionary, operationCheckType) {
    const operationTypeStr = this.operationTypeToString(operationCheckType);
    if (!operationCheckDictionary || !operationCheckDictionary[operationTypeStr]) {
      return {
        Data: {},
        EffectDescription: "",
        Gates: [],
        IsDisabled: false,
        Name: ""
      };
    }
    return operationCheckDictionary[operationTypeStr];
  }
  getGateMessagesDict(operationCheckDictionary, operationCheckType, infoOnly = false) {
    const operationTypeStr = this.operationTypeToString(operationCheckType);
    if (!!operationCheckDictionary && !!operationCheckDictionary[operationTypeStr]) {
      const operationCheck = operationCheckDictionary[this.operationTypeToString(operationCheckType)];
      if (!!operationCheck.Gates) {
        const operationGates = infoOnly ? operationCheck.Gates.filter((gate) => gate.InfoLevel === DisabledInfoLevel.InfoOnly) : operationCheck.Gates.filter((gate) => gate.InfoLevel !== DisabledInfoLevel.InfoOnly);
        if (operationGates.length > 0) {
          const messages = _.map(operationGates, (gate, index) => {
            var _a, _b;
            const message = `${this.CheckAndGetSeedfinderFailMessage(operationCheckType, gate)}${gate.MoreInfoHtml ? ` ${gate.MoreInfoHtml}` : ""}`;
            if ((operationCheckType === OperationCheckTypes.Start || operationCheckType === OperationCheckTypes.Transfer) && message.includes("There are running rollout targets that overlap")) {
              return `${message}. Overlapping experiments include: ${(_a = gate.Data) == null ? void 0 : _a.ConflictingExperimentIds}`;
            } else if ((operationCheckType === OperationCheckTypes.Start || operationCheckType === OperationCheckTypes.Transfer) && message.includes("The audience on this team stage may overlap")) {
              return `${message}. <br/> If an end user qualifies for multiple stages, they'll be assigned to stage based on this priority: ${(_b = gate.Data) == null ? void 0 : _b.ConflictingExperimentIdsOrderedByPriority}`;
            } else {
              return message;
            }
          });
          return messages;
        }
      }
    }
    return [""];
  }
  getTrafficOverlapsMessage(operationChecks) {
    let messages;
    let target;
    const startOperationTypeStr = this.operationTypeToString(OperationCheckTypes.Start);
    const transferOperationTypeStr = this.operationTypeToString(OperationCheckTypes.Transfer);
    if (!operationChecks || !operationChecks.operationCheckDictionary) {
      return target;
    }
    const operationType = !!operationChecks.operationCheckDictionary[startOperationTypeStr] ? OperationCheckTypes.Start : !!operationChecks.operationCheckDictionary[transferOperationTypeStr] ? OperationCheckTypes.Transfer : null;
    if (!!operationType) {
      messages = this.getGateMessagesDict(operationChecks.operationCheckDictionary, operationType, true);
      _.map(messages, (msg) => {
        if (msg.includes("If an end user qualifies for multiple stages")) {
          target = msg;
        }
      });
    }
    return target;
  }
  getGateMessages(operationChecks, operationCheckType) {
    if (!!operationChecks && !!operationChecks.operationCheckDictionary) {
      return this.getGateMessagesDict(operationChecks.operationCheckDictionary, operationCheckType);
    }
    return [""];
  }
  getGateData(operationChecks, operationCheckType) {
    const operationTypeStr = this.operationTypeToString(operationCheckType);
    if (!!operationChecks && !!operationChecks.operationCheckDictionary && !!operationChecks.operationCheckDictionary[operationTypeStr]) {
      const operationCheck = operationChecks.operationCheckDictionary[operationTypeStr];
      if (!!operationCheck.Gates && operationCheck.Gates.length > 0) {
        return _.map(operationCheck.Gates, (gate) => gate.Data);
      }
    }
    return [{}];
  }
  getOperationDisableMessage(operationChecks, operationCheckType) {
    let message = _.map(this.getGateMessages(operationChecks, operationCheckType), (reason) => `* ${reason}`).join(" ");
    return `Operation ${this.operationTypeToString(operationCheckType)} is currently disabled 
 ${message}`;
  }
  isOperationCheckOngoing(operationCheckResponse) {
    return !!operationCheckResponse && operationCheckResponse.status === AsyncRequestStatus.Pending;
  }
  getOperationHelpMessage(operationCheckResponse, operationCheckType) {
    if (this.isOperationCheckOngoing(operationCheckResponse)) {
      return "Fetching Permissions";
    }
    const operationChecks = operationCheckResponse.data;
    const operationTypeStr = this.operationTypeToString(operationCheckType);
    if (!!operationChecks && !!operationChecks.operationCheckDictionary && !!operationChecks.operationCheckDictionary[operationTypeStr] && !!operationChecks.operationCheckDictionary[operationTypeStr].IsDisabled) {
      return this.getOperationDisableMessage(operationChecks, operationCheckType);
    }
    return `Click to ${operationTypeStr}`;
  }
  // TODO: update Progression stage view to use getOperationHelpMessage()
  getMarkDownOperationCheckMessage(operationChecks, operationCheckType) {
    return this.getOperationCheckMessages(this.getGateMessages(operationChecks, operationCheckType), operationCheckType);
  }
  getOperationCheckMessages(operationCheckMessages, operationCheckType) {
    const callouts = {};
    callouts[`Operation ${this.operationTypeToString(
      operationCheckType
    )} is currently disabled <span class="fa fa-exclamation-triangle float-right" />`] = _.map(operationCheckMessages, (reason) => `* ${reason}`).join(" ");
    return callouts;
  }
  parseOperationCheckResponse(response, prevData) {
    return {
      status: response.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
      data: {
        operationCheckDictionary: !response.error ? response.operationChecks : (
          /*If there is error, let it remain what it previously has*/
          prevData.data && prevData.data.operationCheckDictionary
        ),
        lastUpdatedTime: /* @__PURE__ */ new Date(),
        error: response.error,
        errorDetails: response.errorDetails
      }
    };
  }
  /**
   * Checks and populates Seedfinder fail gate message during Advance stage.
   */
  CheckAndGetSeedfinderFailMessage(operationCheckType, gate) {
    var _a, _b;
    if (operationCheckType === OperationCheckTypes.Advance && ((_a = gate.Data) == null ? void 0 : _a.Name) === ExperimentStepType.SeedFinder && ((_b = gate.Data) == null ? void 0 : _b.State) === TransitionGateStates.Fail && !!gate.DetailsHtml) {
      return `${gate.DetailsHtml}<br/>`;
    } else {
      return gate.Message;
    }
  }
}
const OperationCheckUtils$1 = new OperationCheckUtils();
export {
  OperationCheckUtils,
  OperationCheckUtils$1 as default
};
//# sourceMappingURL=OperationCheckUtils.js.map
